import React from 'react';
import './Messages.scss';

const Messages = () => (
  <div className="messages">
    <div className="messages__welcome">
      <h2>Welcome to the ESAI Energy Dashboard</h2>
      <p>
        Use the navigation menu to explore energy datasets and visualize trends.
        Select a category below to get started.
      </p>
    </div>
  </div>
);

export default Messages;
